import Swal from "sweetalert2/dist/sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default Swal;

export const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: toast => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
});

export function SwalConfirm(fun, callback) {
    swalWithBootstrapButtons
        .fire({
            title: "Sei sicuro?",
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sì",
            cancelButtonText: "No",
            reverseButtons: true,
        })
        .then(result => {
            if (result.value) {
                fun().done((res)=>{
                    swalWithBootstrapButtons.fire("Operazione effettuata con successo!", "", "success");
                    callback(res);
                }).fail((res)=>{
                    swalWithBootstrapButtons.fire("Operazione non riuscita", "", "error");
                    callback(res);
                });
            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                swalWithBootstrapButtons.fire("Annulato", "", "error");
            }
        });
}
